import React from 'react';
import { Grid, TextInput, Text, Stack, Divider } from '@mantine/core';
import type { UnitActivityDetail } from '../../../stores/types';
import {
  taskDetailsCompactLabelProps,
  taskDetailsFieldLabel,
  taskDetailsReadOnlyFieldStyles,
} from './taskDetailsFormUtils';

export interface TaskTrackingDetailsSectionProps {
  unitActivityDetails?: UnitActivityDetail[] | null;
}

/**
 * WBS / unit-activity tracking rows (read-only).
 * "Track task" lives in the task details header when conversion is available.
 */
export function TaskTrackingDetailsSection({
  unitActivityDetails,
}: TaskTrackingDetailsSectionProps) {
  const rows = Array.isArray(unitActivityDetails) ? unitActivityDetails : [];
  if (rows.length === 0) return null;

  return (
    <Stack gap="sm" mt="lg" pt="xs">
      <Text size="sm" fw={600}>
        Task tracking details
      </Text>

      <Stack gap="sm">
        {rows.map((r, idx) => (
          <Stack key={r.id} gap={6}>
            {idx > 0 ? <Divider variant="dashed" /> : null}
            <Grid gutter="md">
              <Grid.Col span={12}>
                <TextInput
                  label={taskDetailsFieldLabel(`Activity Name (UA ID - ${r.id})`)}
                  value={r.activityTypeTitle}
                  readOnly
                  styles={taskDetailsReadOnlyFieldStyles}
                  labelProps={taskDetailsCompactLabelProps}
                />
              </Grid.Col>
            </Grid>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
}
